module.exports = __webpack_public_path__ + "img/evaluate.bdde91fa.png";